export function renderMissingViewerDomHierarchy(domElement: HTMLElement) {
    // generate missing dom hierarchy
    if ($(domElement).find('#potree_map').length === 0) {
        let potreeMap = $(`
        <div id="potree_map" class="mapBox" style="position: absolute; left: 100px; top: 70px; width: 400px; height: 400px; display: none">
            <div id="potree_map_header" style="position: absolute; width: 100%; height: 25px; top: 0px; background-color: rgba(0,0,0,0.5); z-index: 1000; border-top-left-radius: 3px; border-top-right-radius: 3px;">
            </div>
            <div id="potree_map_content" class="map" style="position: absolute; z-index: 100; top: 25px; width: 100%; height: calc(100% - 25px); border: 2px solid rgba(0,0,0,0.5); box-sizing: border-box;"></div>
        </div>
    `);
        $(domElement).append(potreeMap);
    }

    if ($(domElement).find('#psp_upgrade_to_pro').length === 0) {
        let pspUpgradeToPro =
            $(`<a href="#" id="psp_upgrade_to_pro"  title="Upgrade to Pro" class="btn green btnupgradtopro"
            href="JavaScript:void(0)" data-placement="bottom" data-toggle="popover"	data-content="Upgrade to Pro"
            style="display:none; box-shadow: 0px 3px 9px -3px #000000a3"
        > Upgrade to Pro </a>`);
        $(domElement).append(pspUpgradeToPro);
        pspUpgradeToPro[0].addEventListener('click', () => {
            let urlPathUpgradeToPro = PSPCustomization.getUrlPathUpgradeToPro();
            window.open(urlPathUpgradeToPro, '_blank');
        });
    }

    if ($(domElement).find('#potree_orgname').length === 0) {
        let potreeOrgName = $(
            `<div id="potree_orgname" class="potree_info_text"></div>`
        );
        $(domElement).append(potreeOrgName);
    }

    if ($(domElement).find('#potree_description').length === 0) {
        let potreeDescription = $(
            `<div id="potree_description" class="potree_info_text"></div>`
        );
        $(domElement).append(potreeDescription);
    }

    if ($(domElement).find('#logo_team').length === 0) {
        let potreeLogoTeamDiv = $(
            `<div id="logo_team" style="position: absolute;top: 60px;	left: 50%; transform: translateX(-50%);	text-align: center;	z-index: 1000;"></div>`
        );
        let potreeLogoTeamImg = $(
            `<img id="logo_team_image" src="" alt="" class="logoimage" style="width: 100px; height: auto; max-height: 150px; object-fit: cover;" />`
        );
        potreeLogoTeamDiv.append(potreeLogoTeamImg);
        $(domElement).append(potreeLogoTeamDiv);
    }

    if ($(domElement).find('#potree_watermark').length === 0) {
        let potreeWatermark = $(
            `<div id="potree_watermark" class="potree_watermark_text"> </div>`
        );
        $(domElement).append(potreeWatermark);
    }

    if ($(domElement).find('#potree_annotations').length === 0) {
        let potreeAnnotationContainer = $(`
        <div id="potree_annotation_container" 
            style="position: absolute; z-index: 100000; width: 100%; height: 100%; pointer-events: none;"></div>`);
        $(domElement).append(potreeAnnotationContainer);
    }
}
